// src/utils/santaApi.js
//
// Builds Santa API URLs in one place.
//
// Preview any moment without waiting for December: open the site with
//   https://flightdeck.info/?santaAt=2026-12-24T16:05:00Z
// and every Santa request is made "as of" that time (the backend honours ?at=).

export function santaUrl(path) {
  const base = `${process.env.REACT_APP_API_URL}/api/santa/${path}`;

  try {
    const at = new URLSearchParams(window.location.search).get("santaAt");
    if (at) return `${base}?at=${encodeURIComponent(at)}`;
  } catch {
    // no window / blocked access: fall through to the real clock
  }

  return base;
}
